import OrderManagementService from '@/views/Order/OrderManagementService';
import {
  APPLY_FILTERS,
  SET_CLIENT,
  SET_ITEMS,
  RESET_CLIENT_STATE
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },

  resetClientState({ commit }) {
    commit(RESET_CLIENT_STATE);
  },

  async getOrderList({ commit, state }, showLoader = true) {
    const { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment } = await OrderManagementService.getOrderList(state.filters, showLoader);

    commit(SET_ITEMS, { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment });
  },

  async getMyOrderList({ commit, state }, showLoader = true) {
    const { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment } = await OrderManagementService.getMyOrderList(state.filters, showLoader);

    commit(SET_ITEMS, { items, total, countUnclaimed, countPending, countContact, countQuoted, countAppointment });
  },

  async getClientByPhoneNumber({ commit }, phoneNumber, showLoader = true) {
    let client;
    try {
      client = await OrderManagementService.getClientByPhoneNumber(phoneNumber, showLoader);
    } catch(e) {
      // quick workaround for bug in edit order popup
      client = undefined;
    }

    commit(SET_CLIENT, client);
  }
};
